import { render, staticRenderFns } from "./auto-message-message-ctrls.vue?vue&type=template&id=135ff121&scoped=true&"
import script from "./auto-message-message-ctrls.vue?vue&type=script&lang=js&"
export * from "./auto-message-message-ctrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ff121",
  null
  
)

export default component.exports